
$(document).ready(function () {
    var _PageScript = (function () {
        var $scope = $(".page-secciones-index"),
            page = 0,
            total = parseInt($("#total").val());

        // ZONA DE FUNCIONES

        var funciones = {

            loadMore: function () {
                page += 1;
                __Ajax({
                    url: "/series?handler=LoadMore",
                    data: {
                        "page": page
                    },
                    start: function () {
                    },
                    done: function (response) {

                        $(".serie-list").append(response.View);
                        if (total === parseInt($(".serie-list-item").length)) {
                            $(".btn-more").addClass("d-none");
                        }
                    },
                    end: function () {
                      }
                });
            },
            f2: function () { }
        };

        // FIN ZONA DE FUNCIONES

        return {
            init: function () {

                // FUNCIONES DE INICIALIZACIÓN
                __site.publiLocal = true;
                // FIN DE FUNCIONES DE INICIALIZACIÓN

                // ZONA DE EVENTOS
                $scope.on('click', ".btn-more", function () {
                    // Aquí puedes llamar a las funciones que necesites
                    funciones.loadMore();
                });
                // FIN ZONA DE EVENTOS
            }
        }

    })();

    _PageScript.init();
});
